import * as React from "react";
import * as PropTypes from "prop-types";
import { formatDate } from "@sse-digital-services/design-system";
import TaskActionButton from "../../buttons/taskActionButton";
import { CardActions } from "@mui/material";
import useProcureToPayRequestItemTasks from "../../../services/apiUtils/hooks/useProcureToPayRequestItemTasks";
import BaseTaskCard from "../baseTaskCard";

const PtpRequestItemTaskCard = ({ id, isDashboard }) => {
    const { ptpRequestItemTaskById } = useProcureToPayRequestItemTasks();
    const { updatedDate, url, requestedFor, createdDate } =
        ptpRequestItemTaskById(id);

    const rows = [
        { field: "Request Item", value: id },
        { field: "Updated", value: formatDate(updatedDate) },
    ];
    !isDashboard &&
        rows.push(
            { field: "Requested for", value: requestedFor },
            { field: "Submitted", value: formatDate(createdDate) }
        );

    return (
        <BaseTaskCard
            isDashboard={isDashboard}
            fields={rows}
            title={`Procure To Pay Request`}
        >
            <CardActions sx={{ px: 0 }}>
                <TaskActionButton
                    mode="neutral"
                    action="Respond in Procure To Pay"
                    url={`https://${url}`}
                />
            </CardActions>
        </BaseTaskCard>
    );
};

PtpRequestItemTaskCard.propTypes = {
    id: PropTypes.string.isRequired,
    isDashboard: PropTypes.bool,
};

export default PtpRequestItemTaskCard;
